import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M22.648 7.516c.569.526.89 1.255.89 2.016v8.372c0 .733-.613 1.327-1.37 1.327H9.832c-.757 0-1.37-.594-1.37-1.327V9.532c0-.761.321-1.49.89-2.016l5.73-5.174a1.404 1.404 0 0 1 1.836 0l5.73 5.174ZM10.615 9.53a.59.59 0 0 1 .193-.428L16 4.415l5.192 4.688a.591.591 0 0 1 .193.43v7.544h-10.77V9.53Z" clip-rule="evenodd"></path><path d="M6.422 13.732C3.7 15.108 2 17.063 2 19.232c0 3.756 5.103 6.871 11.78 7.444l-2.57 1.285a1.077 1.077 0 0 0 .964 1.926l4.535-2.267c1.588-.794 1.588-3.06 0-3.853l-4.535-2.268a1.077 1.077 0 0 0-.963 1.927l2.07 1.035c-2.44-.284-4.565-.937-6.16-1.795-2.25-1.212-2.967-2.525-2.967-3.434 0-.808.566-1.934 2.268-3.024v-2.475Z"></path><path d="M25.588 16.213v-2.475C28.304 15.113 30 17.065 30 19.23c0 2.652-2.545 4.985-6.392 6.329a1.098 1.098 0 1 1-.54-2.087l-.001-.007a13.56 13.56 0 0 0 1.811-.801c2.25-1.212 2.968-2.525 2.968-3.434 0-.807-.564-1.93-2.258-3.018Z"></path></g>';
export var UnconstrainedFlyOverOutlineSVG = function UnconstrainedFlyOverOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
UnconstrainedFlyOverOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UnconstrainedFlyOverOutlineSVG);